import { InvalidFieldError } from '@/validation/errors/invalid-field-error';
const formatPhoneNumber = (phoneNumber) => {
    // Remove all non-digits from the input
    if (phoneNumber !== null && phoneNumber !== undefined) {
        phoneNumber = phoneNumber.replace(/\D/g, '');
        // Check if the phone number is in the format 333-333-4444
        if (/^\d{3}-\d{3}-\d{4}$/.test(phoneNumber)) {
            return phoneNumber;
        }
        // Check if the phone number is in the format 3333334444
        if (/^\d{10}$/.test(phoneNumber)) {
            // Reformat the phone number to the format 333-333-4444
            return phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
        }
        // Return null if the phone number is not in a valid format
        return null;
    }
};
export class PhoneValidation {
    constructor(field) {
        this.field = field;
    }
    validate(input) {
        const formattedPhoneNumber = formatPhoneNumber(input[this.field].toString());
        return !formattedPhoneNumber ? new InvalidFieldError() : null;
    }
}
